
import React, { Component } from 'react';
import services from '../../../../services';
import $ from 'jquery'
import TlkTable from '../../../../components/tlelrik/table/tlkTable';
import { Grid, GridColumn as Column, GridToolbar } from "@progress/kendo-react-grid";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { insertItem, getItems13, updateItem, deleteItem, deleteAll } from "./services13";
import { MyCommandCell } from "./MyCommandCell13"
import InserirFiscalizacao from '../InserirFiscalizacao';
import Swal from "sweetalert2";

var ThisSetState = null;
var arrayData = []
var arrayDataOnEdit = []
var idAutoe;
var DropDownDisableValue = true;
var ThisDropDownDisable = null;
var idAutoPassagem;
var indexEntrada = 0

const arrayLengthValidator = (value) =>
  value && value.length ? "" : "Please add at least one record.";
const queryString = require('query-string');
var moment = require('moment')
const dateFormat = "DD-MM-YYYY";
const fullDateFormat = "DD-MM-YYYY HH:mm:ss";
let listdefaultRequest = { Filters: null, "SortBy": "id", "IsSortTypeDESC": true, "IsPagination": true, "Page": 1, "PageSize": 100 }
let today = new Date();
let current_date = moment(today).format(dateFormat);
today.setDate(today.getDate() - 7);
let LastWeek = moment(today).format(dateFormat);

today = new Date();
today.setDate(today.getDate() - 14);
let Last2Week = moment(LastWeek).format(dateFormat);

today = new Date();
today.setMonth(today.getMonth() - 1);
let Pastmonthdate = moment(today).format(dateFormat);
const editField = "inEdit"; 
let parsed = queryString.parse(window.location.search);
var idAutoQuery = parsed.idAuto
//var DesselagemQuery = parsed.Desselagem 

let tablesjson = {
    "LinhasFatura": {
        columnkeyMap: {
            "tipoVasilha" : "Tipo Vasilha",
            "numeroVasilha" :  "Nº Vasilha",
            "quantidadeAferida" : "Capacidade Aferida (L)",
            "quantidadeFinal" : "Quantidade Apurada (L)",
            "falta" : "Falta(L)",
            "contaCorrenteDesc": "Produto (NC;GA;IG)",
            "selosSeguranca" : "Selos de Segurança",
            "etiquetasSegurancaSelagemVasilhas" : "Etiquetas",
            "sinetes" : "Sinetes",
            "numeroGarrafasRecolhaAmostra" : "Nº Garrafas",
            "capacidadeRecolhaAmostra" : "Capacidade" ,
            "etiquetasSegurancaRecolhaAmostrasVasilhas" : "Etiquetas Segurança",
        },
        actionbuttons: { Delete: "apagar" },
        listApilink: "/Fiscalizacao/GetAutoDetalhe",
        requestMethod: "get",
        notAction: false,
        Filters: {"idAuto" : parseInt(idAutoQuery)},
    },
}


class ClassGrid13 extends Component {
    /* Primeiro passo na acomodação da classe */
    

    constructor(props) {
        super(props);
        this.state = {
            linkData: tablesjson[this.props.tableName],
            telkikTable: null,
            popUpForm: null,
            tlkState: null,
            findnonDocumentedRow: 0,
            error : null,
            filtroEntidade: null,
            artigo: [],
            Auto:null,
            Columns:[],
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
        console.log("Detalhes da grid", this.props.columnList);
        ThisSetState = this;

        this.defaultState();

        (async () => {
            this.setState({
                data: await getItems13(),
                Columns: this.props.columnList
            }); 
        })();
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = (preProp) => {
        if (preProp.date !== this.props.date || preProp.tableName !== this.props.tableName) {
            console.log("update",this.props,preProp)
            this.defaultState();
        }
    }

    static getGridDetails(){
        return idAutoe 
    }
    /* Para obter filtros para a API */
    getAllFilter = () => {
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        return Request.Filters ;
    }


    /*  Para excluir uma linha da base de dados no servidor */

    handleDelete = async (id) => {
        let link = this.state.linkData.deleteAPILink;
        let res = await services.apiCall.requestApi(link + "/" + id, {}, 'post')
        if (res) {
            this.defaultState();
        }
    }

    /* Carregar estado de página padrão  */

    defaultState = () => {
        let linkData = { ...tablesjson }
        linkData = tablesjson.LinhasFatura;   
    }

    deleteFunc = async (_row) => {
        var data = [];
        var datax = { ...this.state.data };
        
        const propertyNames = Object.values(datax);
        console.log(propertyNames)

        for (let index = 0; index < propertyNames.length; index++) {
            var datay = propertyNames[index].idAutoDetalhe;

            if(datay != _row.idAutoDetalhe){
               data.push(datax[index])
            }
        console.log("--------> matches" , data)
        this.setState({
           data:data
        }, () => this.getListDataDelete())
        }
}
getListDataDelete = async () => {
           
    if (!this.state.linkData) return
   
    if (this.state.linkData.singleEntity) {
        this.setState({
            totalcount: 0,
            telkikTable: null,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
        })
    }
  
 
    let columnkeyMap = this.state.linkData.columnkeyMap;
    console.log("OUTRO OBJETO" , Request)
    console.log(this.state.data , "-----> this.state.data" )
    if(this.state.data != undefined){
        var res = this.state.data
        //temRequest = false
        var invoicecode = [];
        let findnonDocumentedRow = 0;
     
        if (res && res.length > 0) {
            res.map((_row, index) => {
                if (_row.invoiceHistory && _row.invoiceHistory.length > 0) {
                    
                    _row.invoiceHistory.map((_r, i) => {
                        invoicecode = [];
                        if (_r.file_Link && _r.invoiceType) {
                            invoicecode = _r.invoiceType.split("-");
                            if (invoicecode[0] === "IVF" || invoicecode[0] === "IVP" || invoicecode[0] === "API") {
                                _row.document_url = "/api/" + _r.file_Link.replace("file:///C:/DevelopmentIVPD", "");
                            } else {
                                _row.invoice_url = "/api/" + _r.file_Link.replace("file:///C:/DevelopmentIVPD", "");
                            }
                        } else {
                            findnonDocumentedRow = findnonDocumentedRow + 1;
                        }
                    })
                } else {
                    findnonDocumentedRow = findnonDocumentedRow + 1;
                    console.log("AGORA" , _row)
                }
                Object.keys(columnkeyMap).map(function (key) {
                    if (key === "selosSeguranca") {
                        for (let index = 0; index < _row.selosSeguranca.length; index++) {
                            var selo = _row.selosSeguranca[index].selo
                            if(index == 0){
                                var sequencia = selo
                            }else{
                                var sequencia = sequencia + "," + selo 
                            }
                            _row[columnkeyMap[key]] = sequencia
                        }
                    } else if (key === "etiquetasSegurancaRecolhaAmostrasVasilhas") {
                        for (let index = 0; index < _row.etiquetasSegurancaRecolhaAmostrasVasilhas.length; index++) {
                            var selo = _row.etiquetasSegurancaRecolhaAmostrasVasilhas[index].etiqueta
                            if(index == 0){
                                var sequencia = selo
                            }else{
                                var sequencia = sequencia + "," + selo 
                            }
                            _row[columnkeyMap[key]] = sequencia
                        }
                    }else if (key === "etiquetasSegurancaSelagemVasilhas") {
                        for (let index = 0; index < _row.etiquetasSegurancaSelagemVasilhas.length; index++) {
                            var selo = _row.etiquetasSegurancaSelagemVasilhas[index].etiqueta
                            if(index == 0){
                                var sequencia = selo
                            }else{
                                var sequencia = sequencia + "," + selo 
                            }
                            _row[columnkeyMap[key]] = sequencia
                        }
                    
                    }else
                        _row[columnkeyMap[key]] = _row[key]
                })
                if (_row.document_type === "Invoice") {
                    _row.document_type = "Movements"
                } else if (_row.document_type === "Credit") {
                    _row.document_type = "Crédito"
                }
            });
            console.log("Akash","1",res);
            idAutoe = res
            idAutoPassagem = Request
            this.setState({
                data: res,
                filterData: res,
                totalcount: res.length,
                findnonDocumentedRow
            }, () =>{
                console.log("Akash","2");
                this.createTabel()
            });
        }else{
            this.setState({
                data: res,
                filterData: res,
                totalcount:0
            },()=>{
                this.createTabel()
            })
        }
    }
    
    
   

}
    /*Para obter dados para a tabela usando apis */

    getListData = async () => {
        try {
            if (!this.state.linkData) return
            let Request = this.getAllFilter();
            if (this.state.linkData.singleEntity) {
                this.setState({
                    totalcount: 0,
                    telkikTable: null,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                })
            }
            if (this.state.linkData.singleEntity && (!Request.Filters.entity_id && !Request.Filters.invoice_id)) return
            let method = this.state.linkData.requestMethod;
            let link = this.state.linkData.listApilink;
            let columnkeyMap = this.state.linkData.columnkeyMap;
            console.log("OUTRO OBJETO" , Request)
            let res = await services.apiCall.requestApi(link, Request, method);
            var invoicecode = [];
            let findnonDocumentedRow = 0;
            // if(DesselagemQuery ==  "true"){
            //     res = res.autoGridGranel
            // }
            
            if (res && res.length > 0) {
                res.map((_row, index) => {
                    if (_row.invoiceHistory && _row.invoiceHistory.length > 0) {
                        
                        _row.invoiceHistory.map((_r, i) => {
                            invoicecode = [];
                            if (_r.file_Link && _r.invoiceType) {
                                invoicecode = _r.invoiceType.split("-");
                                if (invoicecode[0] === "IVF" || invoicecode[0] === "IVP" || invoicecode[0] === "API") {
                                    _row.document_url = "/api/" + _r.file_Link.replace("file:///C:/DevelopmentIVPD", "");
                                } else {
                                    _row.invoice_url = "/api/" + _r.file_Link.replace("file:///C:/DevelopmentIVPD", "");
                                }
                            } else {
                                findnonDocumentedRow = findnonDocumentedRow + 1;
                            }
                        })
                    } else {
                        findnonDocumentedRow = findnonDocumentedRow + 1;
                        console.log("AGORA" , _row)
                    }
                    Object.keys(columnkeyMap).map(function (key) {
                        if (key === "selosSeguranca") {
                            for (let index = 0; index < _row.selosSeguranca.length; index++) {
                                var selo = _row.selosSeguranca[index].selo
                                if(index == 0){
                                    var sequencia = selo
                                }else{
                                    var sequencia = sequencia + "," + selo 
                                }
                                _row[columnkeyMap[key]] = sequencia
                            }
                        } else if (key === "etiquetasSegurancaRecolhaAmostrasVasilhas") {
                            for (let index = 0; index < _row.etiquetasSegurancaRecolhaAmostrasVasilhas.length; index++) {
                                var selo = _row.etiquetasSegurancaRecolhaAmostrasVasilhas[index].etiqueta
                                if(index == 0){
                                    var sequencia = selo
                                }else{
                                    var sequencia = sequencia + "," + selo 
                                }
                                _row[columnkeyMap[key]] = sequencia
                            }
                        }else if (key === "etiquetasSegurancaSelagemVasilhas") {
                            for (let index = 0; index < _row.etiquetasSegurancaSelagemVasilhas.length; index++) {
                                var selo = _row.etiquetasSegurancaSelagemVasilhas[index].etiqueta
                                if(index == 0){
                                    var sequencia = selo
                                }else{
                                    var sequencia = sequencia + "," + selo 
                                }
                                _row[columnkeyMap[key]] = sequencia
                            }
                        }else if (key === "dataPagamento") {
                            _row[columnkeyMap[key]] = _row.dataPagamento
                                ? moment(_row.dataPagamento).format(
                                    fullDateFormat
                                  )
                                : "nd";
                        } else if (key === "entityObject") {
                            _row[columnkeyMap[key]] = _row.entity_id ? _row.entityObject.nome : ""
                        } else if (key === "flag") {
                            _row[columnkeyMap[key]] = _row['flag'];
                        } else if (key === "Invoice_date" || key === "issue_date_time") {
                            _row[columnkeyMap[key]] = moment(_row['issue_date_time']).format(dateFormat);
                        } else if (key === "pag_limit") {
                            _row[columnkeyMap[key]] = _row['deadline_date'] ? moment(_row['deadline_date']).format(dateFormat) : moment(_row['issue_date_time']).format(dateFormat);
                        } else if (key === "is_doc_generated") {
                            _row[columnkeyMap[key]] = parseInt(_row['is_doc_generated']) === 1 ? "Sim" : "Não";
                        } else if (key === "Interest_to_date") {
                            _row[columnkeyMap[key]] = services.money.format(_row.service_tax);
                        } else if (key === "Valor c/ IVA") {
                            _row[columnkeyMap[key]] = services.money.format(_row.total_amount);
                        } else if (key === "valor_cativo") {
                            _row[columnkeyMap[key]] = services.money.format(_row.valor_cativo);
                        } else if (key === "Valor IVA") {
                            _row[columnkeyMap[key]] = services.money.format(_row.iva);
                        } else if (key === "add_Amonut_text") {
                            _row[columnkeyMap[key]] = _row.allTransaction && _row.allTransaction[0] ? _row.allTransaction[0].comment : "";
                        } else if (key === "for_invoice_id") {
                            _row[columnkeyMap[key]] = _row.for_invoice_id ? "Pagamento da Fatura" : "Pagamento Antecipado";
                        } else if (key === "is_paid") {
                            _row[columnkeyMap[key]] = _row[key] === 0 ? "Pendente" : "Não Pendente";
                        } else if (key === "Amount_paid") {
                            _row[columnkeyMap[key]] = services.money.format(_row['amount_paid']);
                        } else if (key === "outgoingAmount" && _row['document_type'] === 'Invoice') {
                            _row[columnkeyMap[key]] = services.money.format(_row.total_amount);
                        } else if (key === "incomingAmount" && _row['document_type'] === 'Credit') {
                            _row[columnkeyMap[key]] = services.money.format(_row.total_amount);
                        } else if (key === "valor") {
                            _row["valor"] = _row.trans_type === "CR" ? _row.total_cr : "-" + _row.total_dr;
                            _row[columnkeyMap[key]] = services.money.format(_row["valor"]);
                        } else if (key === "nifap") {
                            _row[columnkeyMap[key]] = _row.busEntidadeDetail.nifap
                        } else if (key === "nome") {
                            if (_row.busEntidade) {
                                _row[columnkeyMap[key]] = _row.busEntidade[key]
                            }
                            else {
                                _row[columnkeyMap[key]] = _row.busEntidadeDetail.nome
                            }
                        } else if (key === "trans_date") {
                            _row[columnkeyMap[key]] = moment(_row['trans_date']).format(dateFormat);
                        } else if (key === "current_balance") {
                            _row[columnkeyMap[key]] = services.money.format(_row["current_balance"]);
                        } else if (key === "total_amount") {
                            _row[columnkeyMap[key]] = services.money.format(_row["total_amount"]);
                        } else if (key === "local") {
                            _row[columnkeyMap[key]] = _row["key"] || '';
                        } else if (key === "amount_paid") {
                            _row[columnkeyMap[key]] = services.money.format(_row[key]);
                        } else if (key === "trans_amount") {
                            _row[columnkeyMap[key]] = services.money.format(_row["trans_amount"]);
                        } else if (key === "balance") {
                            _row[columnkeyMap[key]] = services.money.format(_row["balance"]);
                        }

                        // else if(key==="document_type" && _row.document_type==="Invoice") {
                        //     _row.document_type = "Movements"
                        // }else if(key==="document_type" && _row.document_type==="Credit") {
                        //     _row.document_type = "Crédito"
                        // }
                        else
                            _row[columnkeyMap[key]] = _row[key]
                    })
                    if (_row.document_type === "Invoice") {
                        _row.document_type = "Movements"
                    } else if (_row.document_type === "Credit") {
                        _row.document_type = "Crédito"
                    }
                });
                console.log("Akash","1",res);
                idAutoe = res
                this.setState({
                    data: res,
                    filterData: res,
                    totalcount: res.length,
                    findnonDocumentedRow
                }, () =>{
                    console.log("Akash","2");
                    this.createTabel()
                });
            }else{
                this.setState({
                    data: res,
                    filterData: res,
                    totalcount:0
                },()=>{
                    this.createTabel()
                })
            }
        } catch (error) {
            this.setState({error})
        }
    }

    /* Para carregar o componente da tabela e definir todas as colunas  */

    createTabel = () => {
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        Request.Filters = { ...Request.Filters, ...this.props.applyedfilter }
        console.log("Request" ,Request)
        
        console.log("STATE" , Request.Filters.entityIdFilter)
        console.log("Akash","3" , Request.Filters.entityIdFilter);
        if (this.state.linkData && this.state.linkData.columnkeyMap) {
            let columnkeyMap = {...this.state.linkData.columnkeyMap}
            if (this.state.findnonDocumentedRow === 0) {
                delete columnkeyMap["Check"]
            }
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
            });
            let actionbuttons = this.state.linkData.actionbuttons;
            console.log("columnlist",columnlist);
            console.log("filterData",this.state.filterData);
            
            let telkikTable = <TlkTable
                date={new Date()}
                generateDocument={this.state.findnonDocumentedRow === 0 ? null : this.state.linkData.generateDocument}
                noDownloadButton={this.state.linkData.noDownloadButton}
                DocumentGERFIP={this.state.linkData.DocumentGERFIP}
                actionColumnName={this.state.linkData.actionColumnName}
                groupfield={this.state.linkData.groupfield}
                modulename={this.state.linkData.modulename || "CriarFatura"}
                notAction={this.state.linkData.notAction}
                tlkState={this.state.tlkState}
                notGroup={true}
                deleteFunc={(id) => this.deleteFunc(id)}
                tableFilters={(filter) => this.tableFilters(filter)}
                list={this.state.filterData}
                actionbuttons={actionbuttons}
                columnlist={columnlist}
                ActionPerform={(action, id) => this.ActionPerform(action, id)} />
            this.setState({
                telkikTable: telkikTable
            })
        }
    }

    /* Obter filtros aplicados na tabela para atualização dinâmica */
    tableFilters = (tlfilter) => {
        console.log("tlfilter",tlfilter);
        try{
            if(JSON.stringify(tlfilter) !== JSON.stringify(this.state.tlkState)){
                let customfilters = this.getAllFilter();
                let columnkeyMap = this.state.linkData.columnkeyMap;
                let tlkState = { ...tlfilter };
                let data = this.makeTlkFilters(tlfilter, columnkeyMap, customfilters);
                let linkData = { ...this.state.linkData };
            
                // linkData.Filters = data.Filters
                this.setState({
                    tlkState,
                    linkData
                }, () => this.getListData());
            }
        }catch(error){
            this.setState({error : error})
        }
        // return data;
    }

    /* Alterações de filtro de tabela em formatos de API */
    makeTlkFilters = (tlkfilter, columnkeyMap, data) => {
        let tlkState
        let inFilters = {};
        let columnkeyMaprev = {};
        // console.log("-----------pppppppppp",columnkeyMap)
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (tlkfilter.filter && tlkfilter.filter.filters && tlkfilter.filter.filters.length > 0) {
            let tkkey = "";
            let tkkeyvalues = [];
            tlkfilter.filter.filters.map((_row, i) => {
                tkkey = "";
                tkkeyvalues = [];
                let checkamount = [];
                if (_row.filters && _row.filters.length > 0) {
                    _row.filters.map((_srow, k) => {
                        tkkey = _srow.field;
                        _srow.value=_srow.value ?_srow.value : ""
                        checkamount =  _srow.value.split(" ")
                        if (checkamount[1] && checkamount[1] === "€") {
                            checkamount[0] = checkamount[0].replace(".", "");
                            checkamount[0] = checkamount[0].replace(",", ".");
                            _srow.value = checkamount[0];
                        }
                        _srow.value = $.isNumeric(_srow.value) ? Number(_srow.value) : _srow.value;
                        tkkeyvalues.push(_srow.value)
                    })
                    tkkey = columnkeyMaprev[tkkey];
                    tkkey = tkkey.toLowerCase();
                    inFilters[tkkey] = tkkeyvalues;
                }
            })
        }
        let defaultRequest = listdefaultRequest;
        defaultRequest.Page = tlkfilter.skip ? (tlkfilter.skip / tlkfilter.take + 1) : 1;
        defaultRequest.PageSize = tlkfilter.take ? tlkfilter.take : 100;
        if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
            defaultRequest.SortBy = columnkeyMaprev[tlkfilter.sort[0].field];
            defaultRequest.IsSortTypeDESC = (tlkfilter.sort[0].dir === "asc") ? false : true;
        }
        // data.inFilters = inFilters;
        return data;
    }

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        console.log("action perform")
        if (this.props.ActionPerform) {
            this.props.ActionPerform(action, row)
        } else {
            let popUpForm = null;
        }
    }

    static removeAllRows(){
        if(ThisSetState){
            ThisSetState.refreshDS(true);
        }
    };

    /*  Para renderizar o conteúdo html da página   */
    static CommandCell = props => <MyCommandCell {...props} edit={ThisSetState.enterEdit} remove={ThisSetState.remove} add={ThisSetState.add} discard={ThisSetState.discard} update={ThisSetState.update} cancel={ThisSetState.cancel} editField={editField} />; // modify the data in the store, db etc

    remove = dataItem => {
      const data = deleteItem(dataItem);
      this.setState({
        data : data
      });
    };

    add = dataItem => {
        var arrayElementos =  []  
        arrayElementos.length = 0
        var inputsGrid = $(".k-grid-table tbody td input#numberboxcell");
        var selectGrid = $("span.k-input");
        for (let index = 0; index < inputsGrid.length; index++) {
            var elementos = inputsGrid[index].value;
            var elementoInput = inputsGrid[index];
            if($(elementoInput).prop("disabled") == false){
                if(elementos == ""){
                    arrayElementos.push(elementos)
                }
            }
        }
        for (let i = 0; i < selectGrid.length; i++) {
            var elementos = selectGrid[i].innerHTML
            if(elementos == ""){
                arrayElementos.push(elementos)
            }
        }
        var multipleselect = $(".k-grid-table tbody td .ant-select-show-search")
        for (let index = 0; index < multipleselect.length; index++) {
            var elementos = multipleselect[index].children
            if(elementos.length == 2 ){
                
            }else{
                arrayElementos.push("")
            }
            
        }
        
        // if(arrayElementos.length > 0){
        //     Swal.fire({
        //         title: 'Têm de preencher todos os campos na grid',
        //         icon: 'error',
        //         confirmButtonText: 'Ok'
        //     })
        // }else{
            dataItem.inEdit = true;
            const data = insertItem(dataItem);
            arrayDataOnEdit = [];
            arrayDataOnEdit.push(dataItem);
            this.setState({
                data: data
            });
        //}

    }

    update = dataItem => {
        dataItem.inEdit = false;
        const data = updateItem(dataItem);
        this.setState({
          data
        });
    }; // Local state operations
  
    discard = () => {
      const data = [...this.state.data];
      data.splice(0, 1);
      this.setState({
        data
      });
      arrayData.splice(0,1);
    };

    cancel = dataItem => {
        this.setState({data:  this.state.data.map(item => item === dataItem ? { ...item,inEdit: false } : item)}); 
    };

    enterEdit = dataItem => {
    console.log(this.state.data)
    if(this.state.data.length > 0){
        // if(dataItem.SelosGarantiaAE != undefined && dataItem.SelosGarantiaIVDP != undefined){
        //     SelectCellSelosGarantia.editeGrid()
        // }
        // if(dataItem.Tipo_Vasilha != undefined){
        //     DropDownCellNVasilha.ChangeValueById(dataItem.Tipo_Vasilha.value)
        // }
        // if(dataItem.Registo_rotulos != undefined){
        //     DropDownCellCorrelativa.ChangeValueById(dataItem.Registo_rotulos)
        // }
        // if(dataItem.Registo != undefined){
        //     DropDownCellCorrelativa.ChangeValueById(dataItem.Registo)
        // }
      
        this.setState({
            data: this.state.data.map(item => item === dataItem ? { ...item,inEdit: true , NewItem :false} : item)
          });
          //$("#tipo_auto option[value='" + dataItem.N_Vasilha_granel.value + "']").attr("selected","selected");
    }else{
        // if(dataItem.SelosGarantiaAE != undefined && dataItem.SelosGarantiaIVDP != undefined){
        //     SelectCellSelosGarantia.editeGrid()
        // }
        // if(dataItem.Tipo_Vasilha != undefined){
        //     DropDownCellNVasilha.ChangeValueById(dataItem.Tipo_Vasilha.value)
        // }
        // if(dataItem.Registo_rotulos != undefined){
        //     DropDownCellCorrelativa.ChangeValueById(dataItem.Registo_rotulos)
        // }
        // if(dataItem.Registo != undefined){
        //     DropDownCellCorrelativa.ChangeValueById(dataItem.Registo)
        // }
        this.setState({
            data: arrayData.map(item => item.ProductID === dataItem.ProductID ? { ...item,inEdit: true ,NewItem :false} : item)
          });
          //$("#tipo_auto option[value='" + dataItem.N_Vasilha_granel.value + "']").attr("selected","selected");
        
    }
      
    };

    itemChange = event => {

        if(event.field == "NumeroGarrafasVendas" || event.field == "CapacidadeVendas"){
            if(event.field == "NumeroGarrafasVendas" && event.dataItem.CapacidadeVendas != undefined){
                var count = (parseFloat(event.value) * parseFloat(event.dataItem.CapacidadeVendas.text.replace(" cl", "")));
                var volumeEmLitros = count / 100;

                if(event.dataItem.TipoProduto.value != "Outros" && event.dataItem.TipoProduto.value != "ProdutosSemConta"){
                    if(parseFloat(event.dataItem.TipoProduto.text.split(" - ")[6]) > parseFloat(volumeEmLitros)){
                        $('.VolumeVendas').text(String(volumeEmLitros))
                        $('.VolumeVendas').val(String(volumeEmLitros))
                        event.dataItem.VolumeVendas = String(volumeEmLitros);
                    }else{
                        $('.VolumeVendas').text("")
                        $('.VolumeVendas').val("")
                        event.dataItem.VolumeVendas = "";
    
                        Swal.fire({
                            icon: 'error',
                            title: 'O valor do volume não pode ser maior que o saldo da conta',
                            text: 'Preencha com valores válidos e volte a submeter',
                        })
    
                    }
                }else{
                    $('.VolumeVendas').text(String(volumeEmLitros))
                    $('.VolumeVendas').val(String(volumeEmLitros))
                    event.dataItem.VolumeVendas = String(volumeEmLitros);
                }
                
                
            }else if(event.field == "CapacidadeVendas" && event.dataItem.NumeroGarrafasVendas != undefined){
                var count = (parseFloat(event.dataItem.NumeroGarrafasVendas) * parseFloat(event.value.text.replace(" cl", "")));
                var volumeEmLitros = count / 100;

                if(event.dataItem.TipoProduto.value != "Outros" && event.dataItem.TipoProduto.value != "ProdutosSemConta"){
                    if(parseFloat(event.dataItem.TipoProduto.text.split(" - ")[6]) > parseFloat(volumeEmLitros)){
                        $('.VolumeVendas').text(String(volumeEmLitros))
                        $('.VolumeVendas').val(String(volumeEmLitros))
                        event.dataItem.VolumeVendas = String(volumeEmLitros);
                    }else{
                        $('.VolumeVendas').text("")
                        $('.VolumeVendas').val("")
                        event.dataItem.VolumeVendas = "";
    
                        Swal.fire({
                            icon: 'error',
                            title: 'O valor do volume não pode ser maior que o saldo da conta',
                            text: 'Preencha com valores válidos e volte a submeter',
                        })
    
                    }
                }else{
                    $('.VolumeVendas').text(String(volumeEmLitros))
                    $('.VolumeVendas').val(String(volumeEmLitros))
                    event.dataItem.VolumeVendas = String(volumeEmLitros);
                }
                
            }
        }

        if(event.field ==  "TipoProduto"){
            if(event.dataItem.NumeroGarrafasVendas && event.dataItem.CapacidadeVendas){
                if(event.value != undefined){
                    if(event.value.value != "Outros" && event.value.value != "ProdutosSemConta"){
                        var count = (parseFloat(event.dataItem.NumeroGarrafasVendas) * parseFloat(event.dataItem.CapacidadeVendas.text.replace(" cl", "")));
                        var volumeEmLitros = count / 100;
        
                        if(parseFloat(event.value.text.split(" - ")[6]) > parseFloat(volumeEmLitros)){
                            $('.VolumeVendas').text(String(volumeEmLitros))
                            $('.VolumeVendas').val(String(volumeEmLitros))
                            event.dataItem.VolumeVendas = String(volumeEmLitros);
                        }else{
                            $('.VolumeVendas').text("")
                            $('.VolumeVendas').val("")
                            event.dataItem.VolumeVendas = "";
        
                            Swal.fire({
                                icon: 'error',
                                title: 'O valor do volume não pode ser maior que o saldo da conta',
                                text: 'Preencha com valores válidos e volte a submeter',
                            })
        
                        }
                    }else{
                        $('.VolumeVendas').text(String(volumeEmLitros))
                        $('.VolumeVendas').val(String(volumeEmLitros))
                        event.dataItem.VolumeVendas = String(volumeEmLitros);
                    }
                }
                
            }
        }


        var data = this.state.data.map(item => event.dataItem != null ?  item.ProductID === event.dataItem.ProductID ? { ...item,
            [event.field || '']: event.field == "TipoProduto" && event.value == undefined ? event.dataItem.TipoProduto :event.value
         } : item : item);
        
       
        this.setState({
            data
        });

    };
    static itemChangeModal = event => {
        ThisSetState.itemChangeModal2(event)
    }
    itemChangeModal2 = event => {  
        $(".left-popup").trigger('click');
    };

    addNew = () => {

        if(!$('.botaoAdicionarNovoEnable').hasClass('disabled')){

            if($('#tabelaNovaAdicionar .k-grid-save-command').length == 0){
                
                    var newDataItem = {
                        inEdit: true,
                        NewItem :true,
                        Discontinued: false,
                       
                    };
                
                if(arrayData.length > 0){
                    this.setState({
                        data: [newDataItem, ...arrayData]
                    });
                }else{
                    this.setState({
                        data: [newDataItem, ...this.state.data]
                    });
                }
                

            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Não pode adicionar quando existe linhas em edição',
                }) 
            }
        }

    };

     refreshDS = (remove) =>{

        this.setState({
            data: []
        })

        arrayData = [];

        deleteAll();
    }

    SetColumnState = () =>{
        this.setState({
            Columns : this.props.columnList
          });
    }

    static updateColumns = () =>{

        ThisSetState.refreshDS(true);

    }
    static updateData = (data) =>{
        ThisSetState.setState({
            data: data
        })
    }
    
    render() {
       
        if(this.state.error){
            throw this.state.error;
        }        
       indexEntrada =+ 1

        if(this.state.data != undefined){
            if(this.state.data.length > 0){
                
                arrayData = this.state.data
                var datagrid = arrayData
                InserirFiscalizacao.getDaraGridMethod(datagrid)
                
            }
        }
        
       
        return (
 
            <div className="custom-k-grid table-section">
                <div className="table-responsive" id='tabelaNovaAdicionar'>

                    <Grid style={{height: "420px"}} data={arrayData.length > 0 ? arrayData : this.state.data } onItemChange={this.itemChange} editField={editField}>
                        <GridToolbar>
                            <button title="Adicionar" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary botaoAdicionarNovoEnable disabled" onClick={this.addNew}>
                                + Adicionar
                            </button>
                        </GridToolbar>
                        {this.props.columnList}
                    </Grid>
                </div>
            </div>
        )
    }
}

export const changeValueSelect = (e) => {

    // SelectCellEtiquetas.changeValueFromSelect(e);
    // SelectCellSelos.changeValueFromSelect(e);
    // SelectCellEtiquetasSelagem.changeValueFromSelect(e);
    // SelectCellSelosSelagem.changeValueFromSelect(e);
    // SelectCellSelosGarantia.changeValueFromSelect(e);

}

export const changeColumnsFiscalizacaoGrid = (auto, typeAuto) => {

};

export default {ClassGrid13};